import styles from './Footer.module.css';

/**
 * Footer status bar component.
 *
 * DOS-style status bar with copyright and quick info.
 */
export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <span className={styles.status}>Ready</span>
      </div>
      <div className={styles.right}>
        <span className={styles.copyright}>
          (C) {currentYear} Full Stack Consulting
        </span>
      </div>
    </footer>
  );
}
